import PropTypes from 'prop-types';
import { deprecatedComponent } from '../core/deprecated-component.js';
import { createComponent } from '../core/create-component.js';
import { SWAN_STYLE_KEY_MAP } from '../head/stylesheets.component.js';

const propTypes = {
    /**
   * Renders the banner with the text on the left and image on the right instead of the other way around
   */ textLeft: PropTypes.bool,
    /**
   * Staggers the banner image on top of the BannerText element
   */ staggered: PropTypes.bool
};
/*
 * @deprecated use `Banner` component instead
 */ const DetailsBanner = deprecatedComponent({
    displayName: 'DetailsBanner',
    description: 'Use `Banner` component instead.',
    root: createComponent({
        displayName: 'DetailsBanner',
        root: 'div',
        propTypes,
        requiredStyleKeys: SWAN_STYLE_KEY_MAP.detailsBanner,
        propConfig: {
            classNames ({ textLeft, staggered }) {
                let classesSet = new Set([
                    'swan-details-banner'
                ]);
                if (textLeft) classesSet.add('swan-details-banner-text-left');
                if (staggered) classesSet = new Set([
                    ...classesSet,
                    'swan-details-banner-background-staggered'
                ]);
                return classesSet;
            }
        }
    })
});
DetailsBanner.defaultProps = {
    staggered: false,
    textLeft: false,
    bgShort: true
};

export { DetailsBanner };
